"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../../../services");
var _constants = require("../../../../utils/constants");
var _CustomIconOrImage = _interopRequireDefault(require("../../../shared/CustomIconOrImage"));
var _widgetSelectors = require("../../../../store/widget/widgetSelectors");
var _useAppSelector = require("../../../../hooks/useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const PlanValueText = _styledComponents.default.span`
  font-weight: bold;
  margin-right: 5px;
`;
const parseSpecValue = spec => {
  if (!spec.valueText) return null;
  const specValues = spec.value.map(val => {
    return val.value >= _constants.UNLIMITED_VALUE ? _services.Services.locale.localeString('Recommendation.PlanUnlimited') : val.value;
  });
  const isAllBooleans = specValues.every(val => typeof val === 'boolean');
  return isAllBooleans ? specValues.every(Boolean) : specValues.join(', ');
};
const getSpecUnit = spec => {
  const ALLOWED_SPECS = ['DATA_NATIONAL', 'roaming'];
  return ALLOWED_SPECS.includes(spec.id) ? spec.valueType : null;
};
const htmlDecode = content => {
  let e = document.createElement('div');
  e.innerHTML = content.replace(/href/g, "target='_blank' href");
  return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
};
const PlanCardInfo = _ref => {
  var _characteristics$find, _characteristics$find2;
  let {
    plan,
    isAdditionalPlan
  } = _ref;
  const characteristics = plan.selectedVariant.characteristics;
  const {
    theme
  } = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectUiSettings);
  const features = (_characteristics$find = characteristics.find(spec => spec.id === 'features')) === null || _characteristics$find === void 0 ? void 0 : (_characteristics$find2 = _characteristics$find.value) === null || _characteristics$find2 === void 0 ? void 0 : _characteristics$find2.map(el => el.value);
  const html = `&lt;ul&gt;${features === null || features === void 0 ? void 0 : features.map(el => `&lt;li&gt;${el}&lt;/li&gt;`).join(' ')}&lt;/ul&gt;`;
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, characteristics.filter(spec => spec.id !== 'features' && spec.id !== 'detailsLink').map((spec, index) => {
    const valueText = parseSpecValue(spec);
    if (!valueText || valueText === '0') return null;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
      layout: {
        sm: [2, 10],
        md: isAdditionalPlan ? [2, 10] : [1, 11]
      },
      spacing: 1,
      verticalAlign: "center"
    }, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
      name: spec.iconName,
      size: isAdditionalPlan ? 3 : 4
    }), theme == _constants.THEMES.ENTEL ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, /*#__PURE__*/_react.default.createElement(PlanValueText, {
      "data-testid": "plan-card-info"
    }, _services.Services.locale.localeString(`Recommendation.${spec.name}`)), valueText, " ", getSpecUnit(spec)) : /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, /*#__PURE__*/_react.default.createElement(PlanValueText, {
      "data-testid": "plan-card-info"
    }, valueText, " ", getSpecUnit(spec)), _services.Services.locale.localeString(`Recommendation.${spec.name}`))), index < characteristics.length - 1 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null));
  }), features !== null && features !== void 0 && features.length ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4,
      bottom: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    weight: 3,
    size: 3
  }, _services.Services.locale.localeString('Recommendation.Includes'))), /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: htmlDecode(html)
    }
  })) : null);
};
var _default = PlanCardInfo;
exports.default = _default;